import { Component, input, Input, TemplateRef } from '@angular/core';
import { RadioFieldModel } from '../../../index';
import { NgTemplateOutlet } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'shared-ui-dynamic-form-radio',
  imports: [NgTemplateOutlet, ReactiveFormsModule, RadioButtonModule],
  template: `
    @if (template) {
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ fieldModel: fieldModel() }"></ng-container>
    } @else {
      <div class="flex flex-wrap gap-4">
        @for (option of fieldModel().options; track $index) {
          <div class="flex items-center gap-2">
            <p-radioButton
              [attr.data-testid]="fieldModel().key + '-' + option"
              [formControl]="fieldModel().control!"
              [name]="fieldModel().key"
              [value]="option"
              [inputId]="option"></p-radioButton>
            <label [for]="option"> {{ option }} </label>
          </div>
        }
      </div>
    }
  `,
  styles: ``,
})
export class DynamicFormRadioComponent {
  @Input() template?: TemplateRef<unknown>;
  readonly fieldModel = input.required<RadioFieldModel>();
}
